import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import moment from 'moment-timezone';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactModal from 'react-modal';
import ReactHtmlParser from 'react-html-parser';
import Message from '../../Common/Message/Message';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './StripeDeviceSelect.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
let terminal = window.StripeTerminal;

class StripeDeviceSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            existingDevices: [],
            selectedDevice: [],
            message: {
                title: '',
                content: '',
                type: ''
            },
            secret: '',
        }
    }

    componentWillUpdate(prevProps) {
        if (prevProps.isStripeDeviceSelectOpen !== this.props.isStripeDeviceSelectOpen) {
            //this.getDevices();
            //this.getConnectionToken();
            this.setConnection();
        }
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    setConnection = () => {
        const _this = this;
        async function fetchConnectionToken() {
            // Your backend should call /v1/terminal/connection_tokens and return the JSON response from Stripe
            const response = await fetch(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/stripe/reader/connection-token`, { 
                method: "POST",
                credentials: 'include'
            });
            const data = await response.json();
            return data.secret;
        }

        function unexpectedDisconnect() {
            alert('Connection lost! Please reconnect your reader.');
            sessionStorage.removeItem('connected_device');
        }

        terminal = window.StripeTerminal.create({
            onFetchConnectionToken: fetchConnectionToken,
            onUnexpectedReaderDisconnect: unexpectedDisconnect,
        });

        // Find Readers on the local network.
        async function discoverReaders() {
            const config = { simulated: false };
            const discoverResult = await terminal.discoverReaders(config);
            console.log('discoverResult', discoverResult);
            if (discoverResult.error) {
                alert('Failed to discover: ', discoverResult.error);
            } else if (discoverResult.discoveredReaders.length === 0) {
                alert('No available readers.');
            } else {
                _this.setState({
                    existingDevices: discoverResult.discoveredReaders,
                });
            }
        }
        discoverReaders();
    }

    handleDeviceSelect = (e) => {
        const value = e.target.value;
        const existingDevices = this.state.existingDevices;
        let selectedDevice = this.state.selectedDevice;
        selectedDevice = existingDevices.filter((existingDevice) => existingDevice.id === value);
        this.setState({
            selectedDevice,
        });
    }
    
    confirmDeviceSelect = async () => {
        const selectedDevice = this.state.selectedDevice[0];
        this.props.toggleStripeDeviceModal(selectedDevice);
    }

    render() {
        return (
            <div>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.props.isStripeDeviceSelectOpen}
                    role={
                        "dialog"
                    }
                    contentLabel={strings.title}
                >
                    <button className="showtix-modal__close" onClick={() => this.props.toggleStripeDeviceModal()} aria-label="Close the modal">&times;</button>
                    <h4 className="modal-title text-center">{strings.title}</h4>
                    <p>{strings.description}</p>
                    <Message
                        message={this.state.message}
                    />
                    <div className="showtix-form__select">
                        <select
                            className="showtix-input"
                            value={this.state.selectedDevice.id}
                            onChange={e => this.handleDeviceSelect(e)}
                        >
                            <option value="">Select your terminal</option>
                            {this.state.existingDevices.map((existingDevice) => (
                                <option value={existingDevice.id}>{existingDevice.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={() => this.confirmDeviceSelect()}
                            disabled={this.state.selectedDevice.length === 0}
                        >
                            {strings.ok}
                        </button>
                    </div>
                </ReactModal>
            </div>
        );
    }
}

StripeDeviceSelect.propTypes = {
    isStripeDeviceSelectOpen: PropTypes.bool,
    toggleStripeDeviceModal: PropTypes.func,
};

export default StripeDeviceSelect;


// WEBPACK FOOTER //
// ./src/components/EventListing/StripeDeviceSelect/StripeDeviceSelect.js